/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';
import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const theaterModeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      x={2}
      y={6}
      width={20}
      height={12}
      rx={1.5}
      fill="none"
      strokeWidth={1.6}
    />
  </svg>
);
export default theaterModeIcon;
